import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import AuthCard from "@/components/AuthCard";
import NewPasswordForm from "@/components/NewPasswordForm";
import { apiError } from "@/lib/errors";

export default function ChangePasswordPage() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  if (user === undefined) return <div className="p-8">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  const forced = !!user.must_change_password;

  const submit = async (pw, current) => {
    try {
      const { data } = await api.post("/auth/change-password", { new_password: pw, current_password: current || null });
      setUser(data);
      toast.success("Password changed");
      nav(Object.values(data.permissions || {}).some(Boolean) ? "/dashboard" : "/");
    } catch (err) { toast.error(apiError(err)); }
  };

  return (
    <AuthCard overline={forced ? "Action Required" : "Account"} title="CHANGE PASSWORD" testid="change-password-page">
      {forced && (
        <p className="text-sm text-slate-700 border-l-4 border-[#E11D48] pl-3 mb-4" data-testid="force-change-notice">
          An administrator requires you to choose a new password before continuing.
        </p>
      )}
      <NewPasswordForm onSubmit={submit} askCurrent={!forced} submitLabel="UPDATE PASSWORD"/>
    </AuthCard>
  );
}
